import http from "../http-common";
const ROOT_URL = process.env.REACT_APP_BASE_URL


export async function loginUser(dispatch, loginPayload) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response = await http.post('/login', JSON.stringify(loginPayload));
        let data = await response.data;
        if (data.token && data.user) {
            dispatch({ type: 'LOGIN_SUCCESS', payload: {"token": data.token, "user": data.user }});
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            return data
        }

        dispatch({ type: 'LOGIN_ERROR', error: data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'LOGIN_ERROR', error: error });
    }
}

export async function logoutUser(dispatch) {
    try {
        dispatch({ type: 'LOGOUT' });
        let response = await http.post('/logout');
        console.log(response)
        if (response.status === 200) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return response
        } else {
            dispatch({ type: 'LOGOUT_ERROR', error: "Error" });
        }
    } catch (error) {
        dispatch({ type: 'LOGOUT_ERROR', error: error });
    }
}

export async function registerUser(dispatch, registerPayload) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response = await http.post(`${ROOT_URL}/api/register`, JSON.stringify(registerPayload));
        let data = await response.data;
        if (data.token && data.user) {
            dispatch({ type: 'LOGIN_SUCCESS', payload: {"token": data.token, "user": data.user }});
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            return data
        }

        dispatch({ type: 'REGISTER_ERROR', error: data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'REGISTER_ERROR', error: error });
    }
}


export async function activateUser(dispatch, activatePayload) {
    try {
        dispatch({ type: 'REQUEST_ACTIVATE' });
        let response = await http.post(`/activate`, JSON.stringify(activatePayload));
        let data = await response.data;
        console.log(response)
        if (data.token && data.user) {
            dispatch({ type: 'ACTIVATE_SUCCESS', payload: data });
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            console.log(data)
            return data
        }
        dispatch({ type: 'ACTIVATE_ERROR', error: data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'ACTIVATE_ERROR', error: error });
    }
}
